module.exports = __webpack_public_path__ + "statics/img/7.043c791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/7.png
// module id = JXvB
// module chunks = 1